/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { ElSharedModule } from '../shared/shared.module';

import { ElActionComponent, ElActionsComponent } from './actions.component';

import { ElBadgeModule } from '../badge/badge.module';
import { ElIconModule } from '../icon/icon.module';

const EL_ACTIONS_COMPONENTS = [
  ElActionComponent,
  ElActionsComponent,
];

@NgModule({
  imports: [
    ElSharedModule,
    ElBadgeModule,
    ElIconModule,
  ],
  declarations: [
    ...EL_ACTIONS_COMPONENTS,
  ],
  exports: [
    ...EL_ACTIONS_COMPONENTS,
  ],
})
export class ElActionsModule { }
